import { notifications } from "@mantine/notifications";

/**
 * Surface a cross-origin download that produced no file (BIO-308 #3).
 *
 * The UI adapter for {@link downloadUrl}'s `onBlocked`: `download.ts` stays
 * DOM-only and this module owns the Mantine dependency, so the four artifact
 * download call sites share one message instead of open-coding it.
 *
 * One message, not two: the signed link expiring/being refused (S3 renders a
 * readable error page) and the transfer being blocked (ad blocker, extension,
 * network policy — the `ERR_BLOCKED_BY_CLIENT` case the ticket reported) are
 * different causes with different remedies, but the cross-origin `<iframe>`
 * events `download.ts` observes don't reliably tell them apart — a blocked
 * request commonly fires the same `load` event a rendered error page does.
 * Asserting a specific cause from an unreliable signal risks telling a
 * blocked user to just retry, which fails the same way again.
 */
export function notifyDownloadBlocked(label: string): void {
  notifications.show({
    title: `${label} did not download`,
    message:
      "The file didn't transfer. This can happen when a signed link expires, or when an ad blocker, extension, or network policy blocks the download — check for a blocker, then try again.",
    color: "red",
    autoClose: 8000,
  });
}
